export function micFormatValidator() {
  return (control) => {
    const mic = control.value;
    if (!mic) {
      return null;
    }
    const regex = /^[A-Z]{4}$/;
    if (!regex.test(mic)) {
      return {
        incorrect: true,
        message:
          'Invalid MIC code. Must be 4 uppercase letters',
      };
    }
    return null;
  };
}
